try {
    window.$ = window.jQuery = require('jquery');
    window.ionRangeSlider = require('ion-rangeslider');
    window.Datatable = require('datatables.net-bs4');
    window.Popper = require('popper.js').default;
    window.Swal = require('sweetalert2');
    window.moment = require('moment');

    require('@veximus/collection');
    require('@veximus/input-badge');
    require('@veximus/input-phone');
    require('@veximus/input-rating');
    require('@veximus/input-search');
    require('@veximus/selection');
    require('@veximus/wizard');

    require('bootstrap');
    require('cleave.js');
    require('datatables.net-responsive-bs4');
    require('daterangepicker');
    require('dropzone');
    require('slick-carousel');
} catch (e) { }

require('./utilities');
require('./main/base');
